// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BillsSummaryHeaderQueryVariables = Types.Exact<{
  unreleasedClickToPayBillsFilter?: Types.InputMaybe<Types.BillFilter>;
  pendingReviewBillsFilter?: Types.InputMaybe<Types.BillFilter>;
}>;


export type BillsSummaryHeaderQuery = { __typename?: 'Query', unreleasedClickToPayBills: Array<{ __typename?: 'Bill', id: string }>, pendingReviewBills: Array<{ __typename?: 'Bill', id: string }> };


export const BillsSummaryHeaderDocument = gql`
    query BillsSummaryHeader($unreleasedClickToPayBillsFilter: BillFilter, $pendingReviewBillsFilter: BillFilter) {
  unreleasedClickToPayBills: bills(filter: $unreleasedClickToPayBillsFilter) {
    id
  }
  pendingReviewBills: bills(filter: $pendingReviewBillsFilter) {
    id
  }
}
    `;

/**
 * __useBillsSummaryHeaderQuery__
 *
 * To run a query within a React component, call `useBillsSummaryHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsSummaryHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsSummaryHeaderQuery({
 *   variables: {
 *      unreleasedClickToPayBillsFilter: // value for 'unreleasedClickToPayBillsFilter'
 *      pendingReviewBillsFilter: // value for 'pendingReviewBillsFilter'
 *   },
 * });
 */
export function useBillsSummaryHeaderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>(BillsSummaryHeaderDocument, options);
      }
export function useBillsSummaryHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>(BillsSummaryHeaderDocument, options);
        }
// @ts-ignore
export function useBillsSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>;
export function useBillsSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillsSummaryHeaderQuery | undefined, BillsSummaryHeaderQueryVariables>;
export function useBillsSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>(BillsSummaryHeaderDocument, options);
        }
export type BillsSummaryHeaderQueryHookResult = ReturnType<typeof useBillsSummaryHeaderQuery>;
export type BillsSummaryHeaderLazyQueryHookResult = ReturnType<typeof useBillsSummaryHeaderLazyQuery>;
export type BillsSummaryHeaderSuspenseQueryHookResult = ReturnType<typeof useBillsSummaryHeaderSuspenseQuery>;
export type BillsSummaryHeaderQueryResult = Apollo.QueryResult<BillsSummaryHeaderQuery, BillsSummaryHeaderQueryVariables>;